import React from 'react'
import { useDispatch } from 'react-redux'
import $t from '../../../i18n'
import Actions from '../../../actions'
import BotPreviewTemplate from '../../common/BotPreviewTemplate'

import './MhBotInfo.css'

const MhBotInfo = () => {
  const dispatch = useDispatch()

  const handleStart = () => {
    dispatch(Actions.createAction(Actions.MENTALHEALTH_BOT_INITED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.MENTALHEALTH_BOT_INITED + '_WEB',
        data: { origin: 'specialty services' },
      })
    )
  }

  const renderTitle = () => {
    return (
      <h1 className="bot-preview-title">
        {$t('pages.getStarted.mhBotInfoDesktop.whatDoWeTreat')}
      </h1>
    )
  }

  return (
    <BotPreviewTemplate
      actions={[
        {
          title: $t('pages.getStarted.mhBotInfoDesktop.letsStart'),
          handleOnClick: handleStart,
        },
      ]}
      contentTitle={renderTitle()}
      contentPoints={[
        $t('pages.getStarted.mhBotInfoDesktop.descriptionPoint1'),
        $t('pages.getStarted.mhBotInfoDesktop.descriptionPoint2'),
        $t('pages.getStarted.mhBotInfoDesktop.descriptionPoint3'),
        $t('pages.getStarted.mhBotInfoDesktop.descriptionPoint4'),
      ]}
    />
  )
}

export default MhBotInfo
